export const ru = {
  common: {
    back: 'Назад',
    retry: 'Повторить',
    loading: 'Загрузка',
    save: 'Сохранить',
    copy: 'Скопировать',
    copied: 'Скопировано',
    failed: 'Не получилось. Попробуй ещё раз.',
    home: 'На главную',
  },

  steps: { label: 'Шаги', thought: 'Мысль', idea: 'Идея', text: 'Формат и текст', voice: 'Озвучка' },

  invite: {
    title: 'Пригласи друзей',
    text: 'Сейчас закрытый запуск: друг попадёт в лист ожидания, а доступ откроет владелец.',
    linkLabel: 'Ваша ссылка',
    share: 'Поделиться',
    copy: 'Скопировать',
    copied: 'Скопировано',
    copyFailed: 'Не вышло скопировать',
    shareText: 'Делаю посты без съёмки: наговариваю мысль голосом — и получаю готовый рилс. Попробуй:',
  },

  shell: {
    tabs: { invite: 'Пригласить', library: 'Копилка', create: 'Создать', credits: 'Кредиты', profile: 'Профиль' },
    menu: 'Меню',
    themeToDark: 'Включить тёмную тему',
    themeToLight: 'Включить светлую тему',
    balance: (credits: number) => `Кредиты: ${credits}`,
  },

  errors: {
    network: 'Нет связи. Проверь интернет и попробуй ещё раз.',
    dailyLimit: (n: number) => `На сегодня всё: не больше ${n} мыслей в день. Завтра продолжим!`,
    noCredits: 'Кредиты закончились. Баланс и сроки — в разделе «Кредиты».',
    tooShort: (n: number) => `Слишком коротко для мысли: нужно хотя бы ${n} знаков.`,
    tooLong: (seconds: number) => `Запись длиннее ${Math.round(seconds / 60)} мин. Раздели мысль на части.`,
    tooLongText: (n: number) => `Слишком длинно: можно не больше ${n.toLocaleString('ru-RU')} знаков.`,
    tooBig: 'Файл слишком большой.',
    unsupportedFormat: 'Не могу прочитать эту запись. Попробуй записать ещё раз.',
    busy: 'Подожди, я ещё работаю над прошлым шагом.',
    versionConflict: 'Текст уже изменился. Показываю свежую версию.',
    formIssues: 'Текст не проходит по длине. Поправь то, что отмечено.',
    emptyAudio: 'Не расслышал. Запиши ещё раз, погромче.',
    nothingToUndo: 'Отменять нечего: это первая версия.',
    notFound: 'Не нашёл. Возможно, это удалили.',
    providerUnavailable: 'Распознавание речи сейчас не отвечает. Попробуй позже или напиши текстом.',
    emptyBlocks: 'Все блоки пустые. Напиши хотя бы один.',
    badPrompts: 'Нужны две разные версии этого шага.',
    noItems: 'В наборе нет ни одной мысли. Добавь хотя бы одну.',
    invalidQuery: 'Странный запрос. Обнови экран и попробуй ещё раз.',
    useRewrite: 'Текст уже написан: чтобы сменить формат, его нужно переписать.',
    sameKind: 'Текст уже в этом формате.',
    styleUnknown: 'У этого формата нет такого стиля. Обнови экран.',
  },

  issues: {
    emptyBlock: (n: number) => `Блок ${n} пустой.`,
    blockTooLong: (n: number, actual: number, max: number) => `Блок ${n}: ${actual} знаков из ${max}.`,
    titleTooLong: (n: number, actual: number, max: number) => `Заголовок слайда ${n}: ${actual} знаков из ${max}.`,
    titleNotAllowed: (n: number) => `Блок ${n}: у рилса нет заголовков.`,
    noLetters: (n: number) => `Блок ${n}: в нём нет ни слова.`,
    tooFew: (min: number, actual: number) => `Блоков ${actual}, а нужно хотя бы ${min}.`,
    tooMany: (max: number, actual: number) => `Блоков ${actual}, а можно не больше ${max}.`,
    badRoles: 'Первый блок должен быть крючком, последний — призывом.',
    reelTooLong: (estimated: string, max: string) => `Рилс звучит ${estimated}, а можно до ${max}. Сократи текст.`,
  },

  units: {
    approx: (value: string) => `≈ ${value}`,
    seconds: (s: number) => `${s} с`,
    minutes: (m: number, ss: string) => `${m} мин ${ss} с`,
    cents: (value: string) => `${value} ¢`,
    dollars: (value: string) => `$${value}`,
    reels: ['рилс', 'рилса', 'рилсов'] as const,
    carousels: ['карусель', 'карусели', 'каруселей'] as const,
    notes: ['заметка', 'заметки', 'заметок'] as const,
  },

  auth: {
    outsideTitle: 'Открой в Telegram',
    outsideText: 'Это приложение работает внутри Telegram. Открой бота и нажми «Открыть приложение».',
    loadingProfile: 'Загружаем профиль',
    errorTitle: 'Не получилось войти',
  },

  waitlist: {
    title: 'Закрытое тестирование',
    text: 'Сейчас вход по приглашениям. Оставь заявку — напишем в бот, когда появится место.',
    noteLabel: 'Пара слов о себе',
    notePlaceholder: 'Чем занимаешься и для кого пишешь',
    submit: 'Оставить заявку',
    added: 'Заявка принята. Напишем в бот, когда откроется доступ.',
    exists: 'Твоя заявка уже в списке. Напишем в бот, когда откроется доступ.',
  },

  entry: {
    welcomeTitle: 'Ты внутри 🎉',
    welcomeText: (credits: string, firstReel: boolean) =>
      `На балансе ${credits}${firstReel ? ' — хватит на первый ролик' : ''}.`,
    start: 'Начать',
    fullTitle: 'Места на сегодня закончились',
    fullText: 'Завтра впустим автоматически и напишем в бот.',
    retry: 'Попробовать ещё раз',
  },

  consent: {
    title: 'Перед началом',
    text: 'Прочитай, какие данные мы храним, кто их видит, и условия сервиса.',
    link: 'Как мы обращаемся с твоими данными',
    offerLink: 'Условия сервиса (оферта)',
    accept: 'Понятно, продолжить',
  },

  home: {
    hello: (name: string) => `Привет, ${name}`,
    heroTitle: 'Наговори мысль',
    heroText: 'До 5 минут, как есть. Я предложу идеи.',
    orType: 'или напиши текстом',
    typePlaceholder: 'О чём хочешь рассказать подписчикам?',
    typeHint: (left: number) => `Ещё ${left} знаков`,
    send: 'Разобрать',
    recent: 'Последние мысли',
    all: 'Вся копилка',
    empty: 'Здесь появятся твои мысли.',
    status: { transcribing: 'Распознаю', ideating: 'Придумываю идеи', ready: 'Идеи готовы', failed: 'Не вышло' },
  },

  recorder: {
    start: 'Нажми и говори',
    stop: 'Готово',
    cancel: 'Отмена',
    left: (mmss: string) => `Осталось ${mmss}`,
    sending: 'Отправляю запись…',
    unsupportedTitle: 'Запись здесь не работает',
    unsupportedText:
      'На этом телефоне приложение не может включить микрофон. Отправь голосовое боту — я разберу его так же.',
    deniedText: 'Нет доступа к микрофону. Разреши его в настройках Telegram или отправь голосовое боту.',
    failedText: 'Не получилось включить микрофон. Попробуй ещё раз или отправь голосовое боту.',
    toChat: 'Отправить голосовое боту',
    micLabel: 'Записать голосом',
    notSent: 'Запись не отправилась.',
    resend: 'Отправить ещё раз',
  },

  thought: {
    title: 'Идеи',
    pickTitle: 'Выбери идею',
    transcribing: 'Распознаю запись…',
    ideating: 'Придумываю идеи…',
    heard: 'Что я услышал',
    showAll: 'Показать всё',
    errors: {
      empty_audio: 'Не расслышал мысль: запись пустая или слишком тихая. Кредиты не списаны.',
      bad_audio: 'Не смог прочитать запись. Запиши ещё раз. Кредиты не списаны.',
      no_audio: 'Запись потерялась по дороге. Запиши ещё раз. Кредиты не списаны.',
      download: 'Не смог скачать запись из чата. Пришли её ещё раз. Кредиты не списаны.',
      provider: 'Сервис идей сейчас не отвечает. Попробуй через пару минут. Кредиты не списаны.',
      format: 'Не получилось разобрать мысль. Попробуй ещё раз. Кредиты не списаны.',
    },
    toHome: 'На главную',
    retry: 'Попробовать ещё раз',
  },

  /** The «вид» of a publication: the segments of an idea card, the draft badge. */
  kinds: {
    reel_scenes: 'Рилс · Сцены',
    reel_diagram: 'Рилс · Схема',
    reel_listicle: 'Рилс · Подборка',
    carousel: 'Карусель',
  },
  types: {
    scenes: 'Сцены',
    diagram: 'Схема',
    listicle: 'Подборка',
  },

  ideas: {
    take: 'Взять',
    open: 'Открыть',
    advice: (kind: string) => `Советуем: ${kind}`,
    adviceKinds: {
      reel_scenes: 'рилс «Сцены»',
      reel_diagram: 'рилс «Схема»',
      reel_listicle: 'рилс «Подборка»',
      carousel: 'карусель',
    },
    reel: 'Рилс',
    carousel: 'Карусель',
    kindUnavailable: 'Этот формат сейчас недоступен — выбери другой.',
    moreRound: 'Ещё идеи',
    more: 'Ещё идеи — один раз, бесплатно',
    noMore: 'Других идей к этой мысли не будет. Нужны новые — надиктуй ещё одну мысль.',
    moreFailed: 'Не получилось придумать ещё. Попробуй снова.',
  },

  draft: {
    hook: 'Крючок',
    cta: 'Призыв',
    block: (n: number) => `Блок ${n}`,
    slide: (n: number) => `Слайд ${n}`,
    slideHook: (n: number) => `Слайд ${n} · крючок`,
    slideCta: (n: number) => `Слайд ${n} · призыв`,
    counter: (n: number, max: number) => `${n} / ${max}`,
    checkFailed: 'Проверка на выдумки сейчас не сработала. Перечитай текст сам.',
    flagsTitle: 'Проверь: этого не было в записи',
    suggestionsTitle: 'Можно добавить',
    add: 'Добавить',
    dismiss: 'Не надо',
    editFailed: 'Правка не удалась. Попробуй ещё раз.',
    title: 'Заголовок',
    /** «Подборка»: the engine takes the codeword of the finale from the last phrase. */
    codewordHint:
      'Хотите, чтобы в конце ролика зрители писали кодовое слово в комментариях? Напишите его в последней фразе заглавными: «Напиши СТАРТ в комментариях — пришлю список». Без кодового слова в конце будет «Подписаться».',
  },

  /** «Формат и текст» (spec 4): the example, format and style, the text edited in place. */
  formatText: {
    screenTitle: 'Формат и текст',
    formats: { reel_scenes: 'Сцены', reel_diagram: 'Схема', reel_listicle: 'Подборка', carousel: 'Карусель' },
    /** «Текст напишется заново под «Схему»». */
    formatsTo: { reel_scenes: 'Сцены', reel_diagram: 'Схему', reel_listicle: 'Подборку', carousel: 'Карусель' },
    format: 'Формат',
    style: 'Стиль',
    carousel: 'Карусель',
    animated: (price: number) => `Анимированная · ${price}`,
    static: (price: number) => `Статичная · ${price}`,
    captionReel: (format: string, style: string) => `Рилс · ${format} · ${style} — пример`,
    captionCarousel: (style: string) => `Карусель · ${style} — пример`,
    lookReel: (format: string, style: string) => `Рилс · ${format} · ${style}`,
    lookCarousel: (style: string) => `Карусель · ${style}`,
    priceReel: (format: string, credits: string) => `Рилс «${format}» — ${credits}`,
    priceCarousel: (animated: boolean, credits: string) => `Карусель ${animated ? 'анимированная' : 'статичная'} — ${credits}`,
    soundOn: 'Включить звук',
    soundOff: 'Выключить звук',
    play: 'Показать пример',
    write: 'Написать текст',
    writing: 'Пишу текст…',
    failed: 'Не получилось написать текст.',
    retry: 'Попробовать ещё раз',
    change: 'Сменить',
    text: 'Текст',
    estimate: (est: string, max: string) => `${est} из ${max}`,
    saving: 'Сохраняю…',
    saved: 'Сохранено',
    saveFailed: 'Не сохранилось — попробую ещё раз',
    conflict: 'Текст изменился в другом окне — показываю свежую версию',
    aiEditing: 'Правлю…',
    addItem: '+ пункт',
    removeBlock: 'Удалить блок',
    check: (quote: string) => `Проверь: «${quote}»`,
    keep: 'Оставить',
    remove: 'Убрать',
    issuesTitle: 'Что поправить',
    undo: 'Отменить правку',
    next: 'Дальше — озвучка',
    build: (credits: string) => `Собрать · ${credits}`,
    buildFree: 'Собрать · бесплатно',
    rewriteTitle: 'Переписать текст?',
    rewriteText: (format: string, left: number, total: number) =>
      `Текст напишется заново под «${format}». Твои правки пропадут. Осталось переписываний: ${left} из ${total}`,
    rewrite: 'Переписать',
    cancel: 'Отмена',
    rewriteLimit: 'Лимит смены формата для этой идеи исчерпан',
    flagsLeft: (n: number, notes: string) =>
      `${n % 10 === 1 && n % 100 !== 11 ? 'Осталась' : 'Остались'} ${notes} — всё равно дальше?`,
    goOn: 'Дальше',
  },

  /** «Озвучка» (spec 5): ready-made voice, my voice or my own reading, manners, the total. */
  voiceScreen: {
    screenTitle: 'Озвучка',
    voice: 'Голос',
    stock: 'Готовый',
    mine: 'Мой голос',
    own: 'Начитаю сам',
    noClone: 'Чтобы ролик звучал твоим голосом, запиши образец — это пара минут. Пока можно взять готовый голос.',
    recordSample: 'Записать образец',
    confirmClone: 'Голос записан, но не подтверждён. Послушай и скажи, похож ли.',
    listenClone: 'Послушать голос',
    manner: 'Манера',
    sample: (who: string, manner: string) => `образец: ${who}, ${manner}`,
    sampleMine: 'мой голос',
    playSample: 'Послушать образец',
    stopSample: 'Остановить',
    listen: 'Послушать с моим текстом',
    voicing: 'Озвучиваю…',
    takesLeft: (left: number, total: number) => `осталось ${left} из ${total} озвучек для этого ролика`,
    takesOver: 'Лимит озвучек для этого ролика исчерпан',
    dailyOver: 'На сегодня озвучки закончились. Завтра можно снова — или начитай сам.',
    voiceBusy: 'Сейчас озвучивается другой голос — подожди, пока закончится, и нажми ещё раз.',
    textChanged: 'Текст изменился — послушать заново?',
    voiceGone: 'Этого голоса больше нет — выбери другой.',
    music: 'Музыка',
    musicOn: 'есть',
    musicOff: 'нет',
    total: (credits: string) => `Итого — ${credits}`,
    totalFree: (used: number, total: number) => `Итого — бесплатно, пересборка ${used} из ${total}`,
    balance: (credits: string) => `На балансе ${credits}`,
    afford: (credits: string, count: string) => `На балансе ${credits} — хватит на ${count}`,
    build: (credits: string) => `Собрать · ${credits}`,
    buildFree: 'Собрать · бесплатно',
  },

  /** «?» hints (spec 6): a title and a few sentences each. */
  help: {
    ok: 'Понятно',
    open: 'Подсказка',
    topics: {
      home: {
        title: 'Как это работает',
        body: 'Наговори мысль голосом или напиши её текстом. Я предложу несколько идей для публикации. Выбери идею — и я напишу текст, озвучу и соберу ролик или карусель.',
      },
      advice: {
        title: 'Почему этот формат',
        body: 'Я смотрю, о чём идея: история, объяснение по шагам, подборка или шпаргалка — и советую формат, который подойдёт лучше. Это только совет: на следующем шаге можно выбрать другой.',
      },
      format: {
        title: 'Форматы',
        body: 'Сцены — ролик из сцен во весь экран: для истории или одной сильной мысли. Схема — один кадр, схема растёт по словам: для объяснения по шагам. Подборка — пункты по одному: сервисы, привычки, ошибки. Карусель — слайды, которые листают и сохраняют.',
      },
      style: {
        title: 'Стиль',
        body: 'Стиль — это только оформление: цвета, шрифты, фон. Текст от него не зависит, поэтому стиль можно менять бесплатно и сколько угодно.',
      },
      carousel: {
        title: 'Анимированная или статичная',
        body: 'Анимированная карусель — слайды с движением, публикуется как видео. Статичная — обычные картинки. Статичная дешевле — цена видна рядом.',
      },
      text: {
        title: 'Текст',
        body: 'У каждого формата свой предел: ролик должен уложиться во время, а слайд — поместиться на экран. Правь прямо в блоках — правки сохраняются сами.',
      },
      flags: {
        title: 'Заметки проверки',
        body: 'Я не выдумываю факты. Если в тексте есть цифра или утверждение, которых не было в твоей записи, я помечаю их. Оставь, если это правда, или убери.',
      },
      codeword: {
        title: 'Кодовое слово',
        body: 'Кодовое слово в конце нужно, только если ты сам что-то раздаёшь: гайд, список, чек-лист. Зрители напишут его в комментариях, а ты пришлёшь обещанное. Если раздавать нечего — в конце будет «Подписаться».',
      },
      voice: {
        title: 'Чей голос',
        body: 'Готовый — один из голосов Google, ничего записывать не нужно. Мой голос — копия твоего голоса по образцу. Начитаю сам — ты читаешь текст в микрофон, а я проверяю запись.',
      },
      myVoice: {
        title: 'Мой голос',
        body: 'Для копии голоса нужен образец на полминуты и фраза согласия — этого требует Google. Записи хранятся только у нас на сервере. Удалить голос вместе с записями можно в настройках одной кнопкой.',
      },
      manner: {
        title: 'Манера',
        body: 'Спокойно — ровно и уверенно. Энергично — бодро, чуть быстрее. Доверительно — тепло и чуть медленнее, как другу. «Само подберёт» выбирает манеру по тексту.',
      },
      takes: {
        title: 'Почему озвучек немного',
        body: 'Каждая озвучка стоит денег, поэтому у ролика их ограниченное число — сколько осталось, видно под кнопкой. Повтор с тем же текстом, голосом и манерой бесплатный и не считается.',
      },
      credits: {
        title: 'Кредиты',
        body: 'Кредиты — внутренняя валюта: ими платят за ролики и карусели. Цена видна перед сборкой. Подаренные кредиты действуют ограниченное время — до какого дня, видно на экране «Кредиты».',
      },
      rebuild: {
        title: 'Пересборка',
        body: 'После сборки можно поправить текст или сменить стиль и собрать заново. Несколько пересборок одного результата бесплатные — сколько осталось, написано здесь.',
      },
      library: {
        title: 'Копилка',
        body: 'Здесь хранится всё твоё: мысли, которые ты наговорил или написал, тексты по идеям и готовые ролики и карусели.',
      },
    },
  },

  library: {
    title: 'Копилка',
    thoughts: 'Мысли',
    texts: 'Тексты',
    more: 'Показать ещё',
    emptyThoughts: 'Мыслей пока нет. Наговори первую — я предложу идеи.',
    emptyCta: 'Наговорить мысль',
    emptyTexts: 'Текстов пока нет. Возьми идею — и я напишу текст.',
    counts: (ideas: number, drafts: number, approved: number) =>
      [`идей: ${ideas}`, drafts ? `текстов: ${drafts}` : null, approved ? `утверждено: ${approved}` : null]
        .filter(Boolean)
        .join(' · '),
    draftStatus: { new: 'Выбор формата', writing: 'Пишу', ready: 'Черновик', editing: 'Правлю', approved: 'Утверждён', failed: 'Не вышло' },
  },

  settings: {
    title: 'Профиль',
    admin: 'Админка',
    signature: 'Подпись автора',
    signatureHint: 'Появится на роликах и каруселях.',
    name: 'Имя',
    handle: 'Ник',
    handleHint: 'Как в Instagram, например @anna.psy',
    handleInvalid: 'Только латиница, цифры, точка и подчёркивание.',
    about: 'О себе',
    aboutHint: 'Я учитываю это, когда придумываю идеи и пишу тексты.',
    aboutEmpty: 'Пока пусто.',
    aboutUpdated: 'Готово: «О себе» обновлено.',
    reRecord: 'Рассказать заново голосом',
    language: 'Язык',
    russian: 'Русский',
    save: 'Сохранить',
    saved: 'Сохранено',
  },

  intro: {
    title: 'Расскажи о себе',
    hint: '30 секунд голосом',
    skip: 'Пропустить',
    processing: 'Слушаю и запоминаю…',
    done: 'Запомнил. Поправить можно в профиле.',
    failed: 'Не получилось, попробуй ещё раз.',
  },

  voice: {
    recognizing: 'Распознаём...',
    recording: 'Идёт запись (отпустите, чтобы остановить)',
    hold: 'Удерживайте, чтобы записать голосом',
  },

  audio: {
    loadFailed: 'Не получилось загрузить звук.',
  },

  voiceSetup: {
    title: 'Образец голоса',
    introTitle: 'Запишем твой голос',
    introText:
      'Нужны две записи подряд, в одном месте: образец — около 25 секунд — и короткая фраза согласия. Найди тихое место и держи телефон как обычно.',
    introManner: 'Читай так, как хочешь звучать в роликах: голос повторит манеру образца.',
    start: 'Начать',
    step1: 'Шаг 1 из 2 · Образец',
    step1Hint: 'Прочитай вслух:',
    step2: 'Шаг 2 из 2 · Согласие',
    step2Hint: 'Сразу после образца, там же, прочитай слово в слово:',
    consentBox:
      'Я владелец этого голоса и согласен, чтобы Google создал по нему синтетический голос для моих роликов. Образец и запись согласия хранятся на сервере бота; удалить их можно в настройках.',
    record: 'Записать',
    stop: 'Готово',
    cancel: 'Отменить',
    again: 'Записать ещё раз',
    checking: 'Проверяю запись…',
    creating: 'Создаю голос — это займёт до 20 секунд…',
    previewTitle: 'Похоже на тебя?',
    previewHint: 'Послушай, как твой голос звучит в роликах.',
    yes: 'Да, похоже',
    no: 'Нет, записать заново',
    done: 'Голос готов 🎉',
    problems: {
      unreadable: 'Не получилось прочитать запись. Попробуй ещё раз.',
      too_short: 'Слишком коротко. Прочитай текст целиком.',
      too_long: 'Слишком длинно. Прочитай только текст с экрана.',
      silent: 'Запись пустая — похоже, микрофон выключен или занят.',
      too_quiet: 'Слишком тихо. Держи телефон ближе и говори обычным голосом.',
      too_loud: 'Звук перегружен. Держи телефон чуть дальше.',
      noisy: 'Слишком шумно. Найди место потише.',
      wrong_text: 'Похоже, прочитан другой текст. Прочитай текст с экрана.',
    },
    consentMismatch:
      'Google не принял запись согласия: фразу нужно прочитать слово в слово, тем же голосом, что и образец. Запиши образец и согласие ещё раз — подряд, в одном месте.',
    limit: 'На сегодня попытки создать голос закончились. Попробуй завтра.',
    unavailable: 'Сервис озвучки сейчас недоступен. Попробуй через несколько минут.',
    retry: 'Попробовать снова',
    unsupported: 'На этом телефоне приложение не может записать звук.',
    permission: 'Нет доступа к микрофону. Разреши его для Telegram в настройках телефона.',
    outdated: 'Приложение обновилось. Закрой его и открой снова.',
    chatTitle: 'Запиши в чате бота',
    chatText:
      'Можно записать голосовыми прямо в чате: бот пришлёт текст образца, а потом фразу согласия. Пришли два голосовых подряд, в одном месте.',
    chatButton: 'Записать в чате',
    chatSent:
      'Бот прислал в чат текст образца. Пришли два голосовых подряд и возвращайся в настройки — послушать голос.',
    openChat: 'Открыть чат',
    chatCancel: 'Передумал, запишу в приложении',
  },

  voiceSettings: {
    title: 'Образец голоса',
    none: 'Голос ещё не записан. Он нужен, чтобы рилсы звучали твоим голосом.',
    pending: 'Голос создан. Послушай и подтверди, что он похож.',
    ready: 'Голос готов: рилсы будут звучать им.',
    record: 'Записать голос',
    listen: 'Послушать и подтвердить',
    rerecord: 'Записать заново',
    delete: 'Удалить голос',
    deleteConfirm:
      'Удалить образец, запись согласия и голос у Google? Чтобы снова озвучивать рилсы своим голосом, его придётся записать заново.',
    deleted: 'Голос удалён.',
    deleteFailed: 'Сервис озвучки сейчас недоступен, голос не удалён. Попробуй позже.',
    cancel: 'Отмена',
  },

  voiceover: {
    manners: {
      auto: 'Само подберёт',
      calm: 'Спокойно',
      energetic: 'Энергично',
      confiding: 'Доверительно',
    },
    failed: {
      voice_mismatch: 'Не получилось чисто озвучить текст. Попробуй ещё раз или начитай сам.',
      unavailable: 'Сервис озвучки сейчас недоступен. Попробуй через несколько минут.',
      other: 'Озвучка не получилась. Попробуй ещё раз.',
    },
    ownLimit: 'На сегодня озвучки закончились — начитку можно будет проверить завтра.',
    ownHint: 'Прочитай текст сам, одним дублем. Мелкие оговорки не страшны.',
    ownRecord: 'Записать начитку',
    ownRerecord: 'Перезаписать',
    ownListen: 'Твоя начитка:',
    ownRejected: 'Похоже, часть текста не прозвучала. Перезапиши, пожалуйста:',
    checkMinor: 'Проверь на слух эти места — проверка могла ослышаться:',
    checkGross: 'Похоже, в озвучке пропал кусок текста. Послушай и реши:',
    revoice: 'Переозвучить',
    issue: {
      missing: (expected: string) => `пропущено «${expected}»`,
      extra: (heard: string) => `лишнее «${heard}»`,
      substituted: (expected: string, heard: string) => `вместо «${expected}» слышно «${heard}»`,
    },
    teleprompterTitle: 'Начитка',
    teleprompterHint: (maxSeconds: number) => `Читай спокойно, как в ролике. Одним дублем, до ${maxSeconds} секунд.`,
    uploading: 'Проверяю запись — это до полуминуты…',
    moreIssues: (n: number) => '…и ещё ' + n,
  },

  render: {
    quoteLine: {
      reel_scenes: 'рилс «Сцены»',
      reel_diagram: 'рилс «Схема»',
      reel_listicle: 'рилс «Подборка»',
      carousel_animated: 'анимированная карусель',
      carousel_static: 'статичная карусель',
      voice_clone: 'озвучка клоном',
    },
    activeBuild: 'Идёт сборка →',
    notApproved: 'Текст ещё не готов к сборке: открой «Формат и текст» и нажми «Дальше».',
    noCredits: (need: number, have: number) => `Не хватает кредитов: нужно ${need}, есть ${have}`,
    toCredits: 'Кредиты',
    /** The same link while something is on sale (spec 3.1). */
    buyCredits: 'Купить',
    formIssues: 'Текст не проходит проверку',
    toText: 'Открыть текст',
    needSignature: 'Укажи подпись автора — она будет в конце ролика',
    toSettings: 'В настройки',
    needVoice: 'Сначала озвучка',

    // The build and result screen (Task 17)
    buildTitle: 'Сборка',
    resultTitle: 'Результат',
    failedTitle: 'Не получилось',
    queued: (ahead: number) => (ahead > 0 ? `В очереди: перед тобой ${ahead}` : 'В очереди: ты следующий'),
    waiting: 'Озвучиваю текст, потом соберу ролик',
    canClose: 'Экран можно закрыть — пришлём в чат',
    stages: {
      start: 'Начинаю',
      align: 'Сверяю голос',
      storyboard: 'Раскадровка',
      layout: 'Раскладываю сцены',
      qc: 'Проверяю текст на экране',
      draw: 'Рисую кадры',
      mix: 'Свожу звук',
      pack: 'Упаковываю',
      done: 'Готово',
      other: 'Собираю',
    },
    download: 'Скачать',
    editAndRebuild: 'Поправить текст и пересобрать',
    otherStyle: 'Другой стиль',
    freeLeft: (n: number) => `Бесплатных пересборок осталось: ${n}`,
    rateQuestion: 'Как тебе результат?',
    rateUp: 'Нравится',
    rateDown: 'Не нравится',
    whatsWrong: 'Что не так?',
    whatsWrongPlaceholder: 'Например: слишком быстро, мелкий шрифт',
    send: 'Отправить',
    rated: 'Спасибо!',
    commentSent: 'Спасибо, передал.',
    refunded: (credits: string) => `Кредиты вернулись: ${credits}`,
    failedAction: {
      text: 'Открыть текст',
      voice: 'Собрать ещё раз',
      ownVoice: 'Записать заново',
      again: 'Попробовать ещё раз',
    },
    notFound: 'Сборка не найдена.',

    // «Готовое» in the library (Task 18)
    readyTab: 'Готовое',
    emptyReady: 'Готовых роликов и каруселей пока нет. Возьми идею, выбери формат — и собери первый.',
    kindReel: 'Рилс',
    kindCarousel: 'Карусель',
    kindCarouselAnimated: 'Анимированная карусель',
  },

  credits: {
    title: 'Кредиты',
    balance: 'Баланс',
    empty: 'Кредитов пока нет',
    validUntilAll: (date: string) => `Действуют до ${date} включительно`,
    burnSoon: (credits: string, date: string) => `${credits} из них сгорят ${date} в 23:59`,
    lotsTitle: 'Откуда кредиты',
    lotLine: (remaining: number, amount: number, date: string) =>
      `${remaining} из ${amount} · до ${date}`,
    /** A purchased lot: it does not burn. */
    lotLineForever: (remaining: number, amount: number) => `${remaining} из ${amount} · без срока`,
    forever: 'Без срока',
    sources: {
      bonus_invite: 'По приглашению',
      bonus_monthly: 'Ежемесячные',
      manual: 'Начисление',
      refund: 'Возврат',
      purchase: 'Покупка',
      bonus_welcome: 'Подарок новичку',
    },
    pricesTitle: 'Сколько что стоит',
    free: 'бесплатно',
    freeRebuilds: (n: number) => `Бесплатных пересборок на один результат: ${n}`,
    monthlyNote: 'Бесплатные кредиты начисляются каждый месяц и сгорают в его конце.',
    priceRows: {
      thought: 'Разбор мысли',
      moreIdeas: '«Ещё идеи» — один раз к мысли',
      text: 'Текст и правки',
      carouselStatic: 'Статичная карусель',
      carouselAnimated: 'Анимированная карусель',
      reel: 'Рилс «Сцены»',
      reelDiagram: 'Рилс «Схема»',
      reelListicle: 'Рилс «Подборка»',
      voiceClone: 'Озвучка клоном, доплата к рилсу',
    },
  },

  /** Buying a pack (spec 3): the «Купить» block, the «Как оплатить» sheet and the waiting. */
  purchase: {
    title: 'Купить',
    sheetTitle: 'Как оплатить',
    methods: {
      kaspi: 'Kaspi',
      lava_card: 'Карта РФ',
      lava_sbp: 'СБП',
      lava_usd: 'Карта другой страны',
      stars: 'Telegram Stars',
    },
    offerBefore: 'Оплачивая, ты принимаешь ',
    offerLink: 'условия оферты',
    otherMethod: 'Другой способ',
    phoneLabel: 'Номер Kaspi',
    phonePlaceholder: '+7 7XX XXX XX XX',
    fromTelegram: 'Взять номер из Telegram',
    sendInvoice: 'Выставить счёт',
    emailLabel: 'Почта для чека',
    emailPlaceholder: 'name@mail.ru',
    toPayment: 'Перейти к оплате',
    payStars: (amount: string) => `Оплатить ${amount}`,
    badPhone: 'Нужен номер Kaspi: казахстанский мобильный +7 7XX',
    badEmail: 'Проверь почту: нужен адрес вида name@mail.ru',
    notKaspiClient: 'Этот номер не подключён к Kaspi. Введи другой',
    kaspiDown: 'Kaspi сейчас недоступен, выбери другой способ',
    refused: (reason: string) =>
      reason ? `Kaspi не выставил счёт: ${reason}. Выбери другой способ.` : 'Kaspi не выставил счёт. Выбери другой способ.',
    unsure: 'Если счёт пришёл в Kaspi — оплати его, кредиты придут сами',
    tooMany: 'Слишком много попыток. Попробуй через час или выбери другой способ',
    unavailable: 'Этот способ сейчас недоступен. Выбери другой',
    error: 'Не получилось. Попробуй ещё раз.',
    waitingKaspi: (amount: string, mask: string) =>
      `Счёт на ${amount} отправлен в Kaspi на ${mask}. Открой Kaspi — там уведомление о счёте — и оплати`,
    waitingLava: 'Ждём оплату…',
    waitingHint: 'Экран сам узнает об оплате — можно не закрывать.',
    openLink: 'Открыть страницу оплаты',
    usdLife: 'Ссылка действует 15 минут',
    newLink: 'Новая ссылка',
    starsWaiting: 'Ждём оплату в окне Telegram…',
    starsPaid: 'Оплачено, кредиты придут через пару секунд',
    paid: (credits: string) => `Оплачено: +${credits}`,
    paidBalance: (balance: number) => `На балансе ${balance}`,
    /** The number the offer asks the buyer to quote in support. */
    orderLine: (code: string) => `Заказ №${code}`,
    failed: 'Оплата не прошла. Выбери способ ещё раз',
    expired: 'Счёт устарел. Выбери способ ещё раз',
    gaveUp: 'Оплата пока не пришла. Если ты оплатил — кредиты придут сами, бот напишет.',
    done: 'Готово',
  },

  admin: {
    title: 'Админка',
    statsLoading: 'Загружаем статистику',
    statsFailed: 'Не удалось загрузить статистику.',
    users: 'Люди',
    usersTotal: 'Всего открывали',
    usersWithAccess: 'С доступом',
    usersWaiting: 'Ждут в листе ожидания',
    usersNew7d: 'Новых за 7 дней',
    usersNew30d: 'Новых за 30 дней',
    creditsBlock: 'Кредиты',
    creditsGranted: 'Начислено',
    creditsSpent: 'Потрачено',
    creditsLive: 'На руках',
    llm: 'Текстовые модели',
    llmSpent: 'Потрачено всего',
    llmBalance: 'Остаток на счёте',
    llmUnavailable: 'OpenRouter недоступен или ключ не задан',
    ratings: 'Оценки сборок за 30 дней',
    ratingsLine: (up: number, down: number, share: number | null) =>
      `👍 ${up} · 👎 ${down}` + (share === null ? '' : ` (${Math.round(share * 100)} % нравится)`),
    ratingsComments: 'Последние «что не так»',
    sourcesTitle: 'Откуда пришли',
    sourcesEmpty: 'Пока никто не пришёл по ссылкам с метками',
    sourceIgPost: 'Instagram, комментарии',
    sourceIgBio: 'Instagram, профиль',
    sourceThDm: 'Threads, личка',
    sourceThBio: 'Threads, профиль',
    sourceCounts: (came: number, first: number, paid: number) => `пришли ${came} · ролик ${first} · купили ${paid}`,
    sourcesTopPosts: 'Посты Instagram, которые привели больше всего',

    invites: 'Приглашения',
    waitlist: 'Лист ожидания',
    settings: 'Цены и пределы',
    broadcast: 'Рассылка',
    prompts: 'Промпты',
    costs: 'Расходы',
    evalSet: 'Проверочный набор',
    participants: 'Участники',

    participantsEmpty: 'Пока никого нет.',
    criteriaTitle: 'Критерии успеха',
    returnsLine: (withTwo: number, people: number, days: number) =>
      `Сделали 2+ результата за первые ${days} дней: ${withTwo} из ${people}`,
    returnsEarly: (n: number) => `Ещё не прошли первые две недели: ${n}`,
    returnsGoal: 'Цель — трое из пяти. Ты сам не считаешься.',
    reelCostLine: (avg: string, max: string, n: number) => `Рилс со всеми тратами: в среднем ${avg}, максимум ${max} (рилсов: ${n})`,
    reelCostRebuilt: (max: string, n: number) => `С двумя пересборками и больше: максимум ${max} (рилсов: ${n})`,
    reelCostNone: 'Готовых рилсов пока нет.',
    reelCostGoal: 'Цель — не дороже 35 центов. Разбор мысли входит целиком, даже если из неё вышло несколько рилсов.',
    participantAdmin: 'админ',
    participantSince: (date: string) => `с ${date}`,
    participantSeen: (date: string) => `был ${date}`,
    participantIdle: 'ещё ничего не делал',
    participantBalance: (credits: string) => `На балансе ${credits}`,
    participantBurns: (credits: string, date: string) => `${credits} сгорят ${date}`,
    participantMade: (thoughts: number, results: number) => `Мыслей ${thoughts} · результатов ${results}`,
    participantRatings: (up: number, down: number) => `👍 ${up} · 👎 ${down}`,
    participantCost: (cost: string) => `Траты на него: ${cost}`,
    participantSource: (label: string) => `Откуда: ${label}`,
    addCredits: 'Добавить кредиты',
    addCreditsAmount: 'Сколько кредитов',
    addCreditsDays: 'На сколько дней',
    addCreditsSubmit: 'Добавить',
    addCreditsBad: 'Кредитов — от 1 до 100 000, дней — от 1 до 365.',
    creditsAddedNotified: 'Добавлено, человек получил сообщение.',
    creditsAddedNotNotified: 'Добавлено, но сообщение не дошло: бот недоступен или человек его заблокировал.',

    inviteCredits: 'Кредитов',
    inviteNote: 'Для кого (заметка для себя)',
    inviteCreate: 'Создать приглашение',
    inviteNoLink: 'Ссылки нет: в настройках сервера не задано имя бота.',
    inviteRevoke: 'Отозвать',
    inviteEmpty: 'Приглашений пока нет.',
    inviteStatus: { open: 'Свободно', used: 'Использовано', revoked: 'Отозвано' },
    inviteUsedBy: (who: string) => `Кто вошёл: ${who}`,

    waitlistEmpty: 'Заявок пока нет.',
    waitlistAdmit: 'Впустить',
    waitlistAdmitted: 'Уже впущен',
    waitlistCredits: 'Сколько кредитов дать',
    waitlistNotified: 'Доступ открыт, человек получил сообщение.',
    waitlistNotNotified: 'Доступ открыт, но сообщение не дошло: человек заблокировал бота.',

    settingsHint: 'Изменения вступают в силу сразу.',
    settingsBad: 'Нужно целое число от 0 до 1 000 000.',
    settingsSaved: 'Сохранено',

    broadcastText: 'Текст сообщения',
    broadcastButton: 'Добавить кнопку «Открыть приложение»',
    broadcastAudience: 'Получат все, у кого есть доступ.',
    broadcastSend: 'Отправить',
    broadcastConfirm: 'Отправить это сообщение всем?',
    broadcastDone: (sent: number, blocked: number, failed: number) =>
      `Отправлено: ${sent}. Заблокировали бота: ${blocked}. Не дошло: ${failed}.`,
  },

  /** The owner's «Пакеты» and «Оплаты» (spec 4.1, 11.1). */
  adminPay: {
    packs: 'Пакеты',
    payments: 'Оплаты',
    packsEmpty: 'Пакетов пока нет',
    packAdd: 'Добавить пакет',
    packNew: 'Новый пакет',
    packEdit: 'Пакет',
    packTitle: 'Название',
    packCredits: 'Кредитов',
    packPriceKzt: 'Цена, ₸',
    packPriceRub: 'Цена, ₽',
    packPriceUsd: 'Цена, $',
    packPriceStars: 'Цена, ⭐',
    packZeroHint: '0 — этим способом пакет не продаётся',
    packStarsHint: (usd: string) => `≈ ${usd} вам`,
    packSort: 'Порядок в списке',
    packAdminsOnly: 'Только админам',
    packActive: 'Показывать',
    packAdminsBadge: 'только админам',
    packHiddenBadge: 'скрыт',
    packBad: 'Название 1–60 знаков, кредитов 1–100 000, цены — целые числа от 0',
    packSaved: 'Сохранено',
    save: 'Сохранить',
    cancel: 'Отмена',
    today: 'Сегодня',
    month: 'Этот месяц',
    noPayments: 'Оплат пока нет',
    totalsLine: (count: number, sum: string) => `${count} · ${sum}`,
    refundsLine: (count: number, sum: string) => `возвраты ${count} · ${sum}`,
    all: 'Все',
    statuses: {
      pending: 'ждёт',
      paid: 'оплачен',
      failed: 'не прошёл',
      expired: 'устарел',
      refunded: 'возврат',
      chargeback: 'чарджбэк',
    },
    ordersEmpty: 'Заказов нет',
    refundStars: 'Вернуть звёзды',
    refundStarsConfirm: (code: string, amount: string) =>
      `Вернуть ${amount} по №${code}? Звёзды вернутся человеку, неистраченные кредиты снимутся.`,
    refundStarsDone: (taken: number, spent: number, credits: number) => `Снято ${taken}, потрачено ${spent} из ${credits}`,
    revoke: 'Снять кредиты',
    revokeConfirm: (code: string, amount: string) =>
      `Деньги по №${code} (${amount}) уже вернул в кабинете платёжки? Неистраченные кредиты снимутся.`,
  },

  adminPrompts: {
    title: 'Промпты',
    steps: {
      transcribe: 'Распознавание речи',
      ideas: 'Идеи',
      text_reel: 'Текст рилса',
      text_carousel: 'Текст карусели',
      text_diagram: 'Текст схемы',
      text_listicle: 'Текст подборки',
      edit: 'Правка текста',
      factcheck: 'Проверка на выдумки',
      profile: 'Рассказ о себе',
    },
    active: 'рабочая',
    versions: 'Версии',
    version: (n: number) => `Версия ${n}`,
    model: 'Модель',
    effort: 'Глубина размышления',
    effortNone: 'нет',
    note: 'Заметка',
    newVersion: 'Новая версия',
    text: 'Текст промпта',
    placeholders: 'Подстановки из паспорта движка (нажми, чтобы вставить)',
    checkModel: 'Проверить модель',
    check: {
      ok: 'Модель подходит.',
      not_found: 'Такой модели нет в OpenRouter.',
      no_structured_outputs: 'Модель не умеет отвечать по строгой схеме.',
      no_reasoning: 'У модели нет настройки глубины размышления — выбери «нет».',
      unavailable: 'OpenRouter не ответил. Попробуй позже.',
    },
    save: 'Сохранить версию',
    saved: 'Версия сохранена. Она ещё не рабочая.',
    activate: 'Сделать рабочей',
    activateConfirm: (n: number) => `Сделать версию ${n} рабочей? Новые мысли и тексты пойдут через неё.`,
    activated: 'Версия стала рабочей.',
    compare: 'Сравнить с рабочей на наборе',
    cancel: 'Отмена',
    unknownPlaceholder: (names: string) => `Неизвестные подстановки: ${names}`,
    invalidModel: 'Модель записывается так: компания/модель, например google/gemini-3.8-flash',
    emptyBody: 'Текст промпта пустой.',
  },

  adminCosts: {
    title: 'Расходы',
    days: (n: number) => `${n} дн.`,
    total: 'Всего',
    calls: (n: number) => `вызовов: ${n}`,
    perThought: 'Разбор мысли в среднем',
    perDraft: 'Текст с правками в среднем',
    count: (n: number) => `за ${n}`,
    byKind: 'По шагам',
    byModel: 'По моделям',
    byDay: 'По дням',
    topUsers: 'Кто больше тратит',
    eval: 'Проверочный набор',
    failed: (n: number) => `неудачных: ${n}`,
    kinds: { transcribe: 'Распознавание', ideas: 'Идеи', text: 'Текст', edit: 'Правки', factcheck: 'Проверка', profile: 'О себе' },
    empty: 'За этот период расходов нет.',
  },

  adminEval: {
    title: 'Проверочный набор',
    set: 'Набор',
    setHint: 'Лучше всего 10–15 настоящих мыслей: твоих и экспертов.',
    setEmpty: 'В наборе пока ничего нет.',
    remove: 'Убрать',
    fromThoughts: 'Добавить из мыслей',
    noThoughts: 'Мыслей с расшифровкой пока нет.',
    toSet: 'В набор',
    added: 'Добавлено в набор.',
    paste: 'Вставить текст',
    itemTitle: 'Название',
    itemText: 'Расшифровка мысли',
    add: 'Добавить',
    runs: 'Сравнения',
    runsEmpty: 'Сравнений пока нет.',
    newRun: 'Новое сравнение',
    versions: (a: number, b: number) => `v${a} и v${b}`,
    picked: (p: number, total: number) => `выбрано ${p} из ${total}`,
    step: 'Что сравниваем',
    versionA: 'Версия А',
    versionB: 'Версия Б',
    versionOption: (n: number, model: string, active: boolean) => `v${n} · ${model}${active ? ' · рабочая' : ''}`,
    estimate: (price: string, items: number) => `Прогон ≈ ${price}: ${items} мыслей × 2 версии`,
    run: 'Прогнать',
    runConfirm: 'Запустить прогон? Он стоит денег.',
    cancel: 'Отмена',
    running: (done: number, total: number) => `Прогоняю: ${done} из ${total}`,
    idea: 'Идея',
    variant: (n: number) => `Вариант ${n}`,
    better: (n: number) => `Лучше ${n}`,
    tie: 'Одинаково',
    failedVariant: (message: string) => `Этот вариант не ответил: ${message}`,
    pendingVariant: 'Ещё не готово.',
    progress: (n: number, total: number) => `${n} из ${total}`,
    reveal: 'Показать итог сейчас',
    result: 'Итог',
    wins: 'Побед',
    ties: (n: number) => `Одинаково: ${n}`,
    failures: 'Сбоев',
    avgCost: 'Цена в среднем',
    avgTime: 'Время в среднем',
    status: { running: 'идёт', done: 'готово', failed: 'не вышло' },
  },
};

export type Dictionary = typeof ru;
